/***************************************************************
Hawaiian Macadamia Nut Services
01/18/2019
Alexander Self
Harvest Report View
- View various graphs, data sets regarding harvest
***************************************************************/
import React, { Component } from 'react';
import HarvestIntroSummary from './report/harvest_intro_summary';
import HarvestMetricsSummary from './report/harvest_metrics_summary';
import HarvestAveragesSummary from './report/harvest_averages_summary';
import HarvestFieldSummary from './report/harvest_field_summary';
import moment from 'moment';


class HarvestReportView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataExists: true
    };
  }
  componentWillReceiveProps(newProps) {
    let { data } = newProps.query;
    if (data.length === 0) {
      this.setState({ dataExists: !this.state.dataExists });
      return;
    }
  }
  render() {
    if (this.props.query.data.length === 0) {
      return (
        <div>
          { this.state.dataExists ? <span>Loading...<br /></span> :
            <div>
              <span>No data exists for this query<br /></span>
              <button className="btn waves-effect" onClick={this.props.selectNewReport}>Select New Report</button>
            </div>
          }
        </div>
      );
    }

    let { dateFrom, dateTo } = this.props.options;
    return (
      <div>
        <div>
          <span><button className="btn waves-effect" onClick={this.props.selectNewReport}>Select New Report</button></span>
          <span className="right flow-text">{moment(dateFrom).format('MM-DD-YYYY')} to {moment(dateTo).format('MM-DD-YYYY')}</span>
        </div>
        <div className="card">
          <HarvestIntroSummary query={this.props.query} />
        </div>
        <div>
          <HarvestMetricsSummary query={this.props.query} options={this.props.options} />
        </div>
        <div className="row">
          <div className="col s12 m6 l6 xl6">
            <HarvestAveragesSummary query={this.props.query} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <HarvestFieldSummary query={this.props.query} />
          </div>
        </div>
      </div>
    );
  }
}

export default HarvestReportView;



/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/view/harvest_report_view.jsx